var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Functions.get_OCSDateTime();
/**
 * @module Viewer
 * @class Controller
 * 
 */
OCS.Viewer.Classes.Controller = new Class({
    Implements: [Options, Events],
    ocsmap: null,
    model: null,
    map_datetime: null,
    events: {},
    active_radar_group_id: null,
    html_controller: null,
    event_manager: null,
    map_id: null,
    map_object: {
        div: null,
        map: null,
        layers: []
    },
    bound_methods: {},
    map_options: {},
    initial_url_ops: {},
    options: {
        debug: OCS.Settings.debug,
        update_url_event_string: 'update_url_event',
        url_update_frequency: 700,
        event_prefix: 'on_',
        events: {
            debug: true,
            play: true,
            pause: true,
            stop: true,
            go_to_first_frame: true,
            go_to_last_frame: true,
            go_to_next_frame: true,
            go_to_previous_frame: true,
            go_to_frame: true,
            change_radar_site: true,
            change_radar_product: true,
            link_map: true,
            unlink_map: true,
            update_panel_options: true
        }

    },
    product: {},
    container: null,
    panel_options: null,
    initialize: function (element, ops) {
        this.bound_methods.update_url_state = this.update_url_state.bind(this);
        this.bound_methods.render = this.render.bind(this);
        this.bound_methods.on_load_radar_console = this.on_load_radar_console.bind(this);
        if (!element) {
            console.warn('OCS.Viewer.Classes.Controller: No container passed!');
            return;
        }
        var obj = element.retrieve('viewer');
        if (obj) {
            return obj;
        }
        this.container = element;
        OCS.Functions.get_OCSDateTime();
        this.setOptions(ops);
        this.addEvent('load_radar_console', this.bound_methods.on_load_radar_console);
        this.addEvent(OCS.Viewer.Config.events.LAYER_VISIBILITY_CHANGED, this.bound_methods.update_url_state);
        this.initialize_events();
        var ctrl_mngr = OCS.Viewer.Functions.get_controller_manager();
        ctrl_mngr.add_map_ctrlr(this);
        OCS.Viewer.Functions.init_utilities();
        element.store('viewer', this);
    },
    initialize_events: function (reference) {
        if (!reference) {
            reference = this;
        }
        Object.each(this.options.events, function (use_event, event) {
            this.register_event(use_event, event, reference);
        }, this);
    },
    register_event: function (use_event, event, reference) {
        var prefix = this.options.event_prefix;
        var method_name;
        if (use_event) {
            method_name = prefix + event;
            if (this[method_name]) {
                reference.addEvent(event, this[method_name].bind(this));
            }
        }
    },
    start: function (product) {
        this.start_managers();
        if (product) {
            this.set_product(product);
            var model = this.get_model();
            if (model.ready) {
                this.create_map();
            }
        }


        var html = this.get_html_controller();
        html.update_countainer_bg_color();
    },
    start_managers: function () {
        OCS.Viewer.Functions.get_data_manager({debug: this.options.debug});
        OCS.Viewer.Functions.get_advisory_manager({debug: this.options.debug});
    },
    /*
     * 
     *   Event Handlers 
     *   
     */
    on_layer_group_added: function (layer_group) {
        layer_group.addEvent(OCS.Viewer.Config.events.PRODUCT_DOWN, this.html_controller.load_alert_box.bind(this.html_controller));
        layer_group.addEvent(OCS.Viewer.Config.events.RENDER_HTML, this.html_controller.load_html.bind(this.html_controller));

    },
    on_load_radar_console: function () {
        var model = this.get_model();
        var radar = model.get_layer('radar').variables[0];
        var util = OCS.Viewer.Functions.get_utilities();
        var product = util.get_radar_product_properties(radar.parm);
        if (!product) {
            product = {'name': null, 'product': null};
        }

        var site = util.get_radar_site_properties(radar.site);
        var options = {
            locations: [],
            selected_product: product.name,
            selected_site: site.id + ' ' + site.name || 'KTLX Oklahoma City',
            selected_site_id: site.id
        };

        OCS.Viewer.Config.default_radar_locations.each(function (location) {
            if (options.selected_site_id === location.id) {
                location.status = 'active';
            } else {
                location.status = '';
            }
            options.locations.push(location);
        }.bind(this));

        var html = this.get_html_controller();
        html.load_radar_console(site, product, options);
    },

    /*
     * @method: on_pause
     * @returns {undefined}
     */
    on_pause: function () {
        var map_datetime = this.get_map_datetime();
        map_datetime.on_pause();
        //this.ocsmap.pause();
    },
    /*
     * @method: on_play
     * @returns {undefined}
     */
    on_play: function () {
        var map_datetime = this.get_map_datetime();
        map_datetime.set_animation_direction(1);
        map_datetime.on_play();
        //this.ocsmap.set_direction(1);
        //this.ocsmap.play();
    },
    /*
     * @method: on_stop
     * @returns {undefined}
     */
    on_stop: function () {
        var map_datetime = this.get_map_datetime();
        map_datetime.on_stop();
        //this.ocsmap.stop();
    },
    on_go_to_first_frame: function () {
        var map_datetime = this.get_map_datetime();
        map_datetime.on_go_to_first_frame();
        //this.ocsmap.go_to_first_frame();
    },
    on_go_to_last_frame: function () {
        var map_datetime = this.get_map_datetime();
        map_datetime.on_go_to_last_frame();
        //this.ocsmap.go_to_last_frame();
    },
    on_go_to_next_frame: function () {
        var map_datetime = this.get_map_datetime();
        map_datetime.on_go_to_next_frame();
    },
    on_go_to_previous_frame: function () {
        var map_datetime = this.get_map_datetime();
        map_datetime.on_go_to_previous_frame();
    },
    on_go_to_frame: function (frame) {
        var util = OCS.Viewer.Functions.get_utilities();
        if (frame && util.isNumber(frame)) {
            var map_datetime = this.get_map_datetime();
            map_datetime.on_go_to_frame({current: frame});
        }
    },
    on_time_update: function (time_update) {
        var html = this.get_html_controller();
        this.timestamp_updated(time_update.get_current_epoch_time());
        if (this.ocsmap && html) {
            html.frame_changed(this.ocsmap.get_layer_groups(), time_update);
            this.get_panel_options().frame_changed(this.ocsmap.get_layer_groups(), time_update);
        }
    },
    on_link_map: function () {
        this.link_map();
    },
    on_unlink_map: function () {
        this.unlink_map();
    },
    on_update_panel_options: function () {
        if (this.ocsmap) {
            var panel_ops = this.get_panel_options();
            if (panel_ops) {
                panel_ops.load_panel_options(this.ocsmap.get_layer_groups());
            }
        }
    },
    on_change_radar_site: function (radar_site_id) {
        var model = this.get_model();
        if (model) {
            model.set_radar_site(radar_site_id);
        }
        this.update_url_state();
    },
    on_change_radar_product: function (radar_product_id) {
        var model = this.get_model();
        if (model) {
            model.set_radar_product(radar_product_id);
        }
        this.update_url_state();
    },
    on_debug: function (cond) {
        this.options.debug = cond;
        if (this.ocsmap) {
            this.ocsmap.set_debug(cond);
        }
    },
    /*
     * 
     * Event Fires
     * 
     */
    controller_event: function (event_name, event_data) {
        this.fireEvent(event_name, event_data);
    },
    map_event: function (event_name, event_data) {
        var ocsmap = this.get_ocsmap();
        if (ocsmap) {
            ocsmap.fireEvent(event_name, event_data);
        }
    },
    load_radar_console: function () {
        this.controller_event('load_radar_console');
    },
    render: function () {
        var model = this.get_model();
        if (!model.ready) {
            return false;
        } else {
            this.model.removeEvent('is_ready', this.bound_methods.render);
        }

        this.resize();
        var map = this.get_ocsmap();
        map.initialize_map(model.get_map_settings());
        map.initialize_layers(model.get_map_layers());
        var datetime = this.get_map_datetime();

        var html = this.get_html_controller();
        if (model.contains_layer('radar')) {
            this.active_radar_group_id = this.ocsmap.active_radar_group_id;
            this.load_radar_console();
        }
        if (model.is_map_animatable()) {
            html.load_map_controls();
        }
        html.init_alert_box();
        this.ocsmap.add_zoom_interaction();
        this.ocsmap.add_zoom_control();

        datetime.time_update();


        if (Object.keys(this.initial_url_ops).length) {
            this.update_product_options(this.initial_url_ops);
        }


        html.apply_map_listeners();
        // This is map specific event so it must come after the map listeners are attached
        this.update_panel_options();
    },
    send_ga_event: function (event) {
        event.entry_id = this.get_entry_id();
        this.controller_event(OCS.Viewer.Config.events.SEND_GA_EVENT, event, 1);
    },
    timestamp_updated: function (ts) {
        this.fireEvent('timestamp_updated', ts);
    },
    update_panel_options: function () {
        this.fireEvent('update_panel_options', this);
    },
    /*
     * Actions
     */

    create_map: function () {
        var map = this.get_ocsmap();
        var view = map.get_map_view();
        if (view) {
            var model_map = this.get_model().get_map_settings();
            view.set_center([model_map.mapLon, model_map.mapLat]);
        }
    },

    resize: function () {
        if (typeof (this.ocsmap) !== 'undefined' && this.ocsmap !== null) {
            this.ocsmap.resize();
        }
    },
    get_entry_id: function () {
        return this.product.entry_id;
    },
    is_map_linked: function () {
        var ctrl_mngr = OCS.Viewer.Functions.get_controller_manager();
        return ctrl_mngr.is_map_linked(this.get_ocsmap());
    },
    link_map: function () {
        if (typeof (this.ocsmap) !== 'undefined') {
            var ctrl_mngr = OCS.Viewer.Functions.get_controller_manager();
            if(ctrl_mngr.link_map(this)) {
                this.fireEvent('map_linked', this);
                return true;
            }
        }
        return false;
    },
    unlink_map: function () {
        if (this.ocsmap) {
            var ocsmap = this.get_ocsmap();
            ocsmap.linked = false;
            var ctrl_mngr = OCS.Viewer.Functions.get_controller_manager();
            if (ctrl_mngr.is_map_linked(this.ocsmap)) {
                ctrl_mngr.unlink_map(this);
                this.update_url_state();
                this.fireEvent('map_unlinked', this);
                return true;
            }
        }
        return false;
    },

    update_product_options: function (ops) {
        var changed = false;
        if (!ops) {
            return;
        }

        var model = this.get_model();
        if (model && model.ready) {
            var html = this.get_html_controller();
            var util = OCS.Viewer.Functions.get_utilities();
            var radar_settings = model.get_map_radar_settings();
            // Radar Site Updates
            if (ops.hasOwnProperty('s') && ops.s !== radar_settings.site) {
                // Validate that this is a valid site.
                var site = util.get_radar_site_properties(ops.s);
                if (site) {
                    model.set_radar_site(site.id);
                    // Update the radar site selector
                    html.update_radar_site(site.id);
                    changed = true;
                } else {
                    // Revert the url back to the original state
                    this.update_url_state();
                }
            }

            // Radar Product Updates
            if (ops.hasOwnProperty('r') && ops.r !== radar_settings.product) {
                // Validate that this is a valid product.
                var product = util.get_radar_product_properties(ops.r);
                if (product) {
                    model.set_radar_product(product.product);
                    // Update the radar product selector
                    html.update_radar_product(product.product);
                    changed = true;
                } else {
                    // Revert the url back to the original state
                    this.update_url_state();
                }
            }


            // Map View Options
            if (this.ocsmap) {
                var radar_layer = model.contains_radar_layer();
                if (changed && radar_layer) {
                    this.ocsmap.update_radar_layer(model.get_map_radar_settings());
                }

                var view = this.ocsmap.get_map_view();
                if (ops.hasOwnProperty('map_center') && ops.map_center) {
                    view.set_center(JSON.parse(ops.map_center));
                }
                if (ops.hasOwnProperty('map_resolution') && ops.map_resolution) {
                    view.set_resolution(ops.map_resolution);
                }
                if (ops.hasOwnProperty('layers_invisible') && ops.layers_invisible) {
                    var layers = JSON.parse(ops.layers_invisible);
                    var layer;
                    Object.each(layers, function (value, layer_name) {
                        layer = this.ocsmap.get_layer_group_with_name(layer_name);
                        if (layer) {
                            layer.set_visible(value);
                        }
                    }.bind(this));
                }
                if (ops.hasOwnProperty('map_linked') && ops.map_linked !== 'false') {
                    this.link_map();
                }

            } else {
                this.initial_url_ops = ops;
            }
        } else {
            this.initial_url_ops = ops;
        }
    },
    update_url_state: function () {
        var new_state = {};
        var model = this.get_model();
        if (model && model.ready) {
            var radar_settings = model.get_map_radar_settings();
            new_state.entry_id = this.get_entry_id();
            new_state.s = radar_settings.site.toUpperCase();
            new_state.r = radar_settings.product.toUpperCase();
            var ocsmap = this.get_ocsmap();
            if (ocsmap) {
                var view = ocsmap.get_map_view();
                if (view) {
                    new_state.map_center = JSON.stringify(view.get_center());
                    new_state.map_resolution = view.get_resolution();
                }
                var nv = ocsmap.get_what_is_not_visible();
                if (nv && Object.keys(nv).length) {
                    new_state.layers_invisible = JSON.stringify(nv);
                } else {
                    new_state.layers_invisible = '';
                }
                if (this.is_map_linked()) {
                    new_state.map_linked = "true";
                } else {
                    new_state.map_linked = "false";
                }


            }
            this.fireEvent(this.options.update_url_event_string, {state: new_state, map_event: true});

        }
    },
    reset_layer_order: function (grouped_layer, minimum_index, old_layer_obj_order) {
        Object.each(grouped_layer.layers, function (layer) {
            this.ocsmap.map.setLayerIndex(layer, minimum_index);
        }.bind(this));
        this.ocsmap.layers_obj[grouped_layer.group_id].order = old_layer_obj_order;
    },

    // Setters and getters
    set_anim_speed: function (speed) {
        this.options.anim_speed = parseInt(speed);
    },
    set_wind_arrows: function (setting) {
        this.options.wind_arrows = setting;
    },
    get_map_datetime: function () {
        if (!this.map_datetime) {
            var model = this.get_model();
            this.map_datetime = model.get_map_datetime();
            this.map_datetime.addEvent('time_update', this.on_time_update.bind(this));
            this.map_datetime.addEvent('send_ga_event', this.send_ga_event.bind(this));
        }
        return this.map_datetime;
    },
    get_current_frame: function () {
        var time = this.get_map_datetime();
        return time.get_current_epoch_time();
    },
    get_html_controller: function () {
        if (!this.html_controller) {
            this.html_controller = new OCS.Viewer.Classes.HtmlController(this.container);
            this.html_controller.set_map_controller(this);
            this.initialize_events(this.html_controller);
            this.html_controller.init();
        }
        return this.html_controller;
    },

    get_ocsmap: function () {
        if (!this.ocsmap) {
            var datetime = this.get_map_datetime();
            this.ocsmap = new OCS.Viewer.Classes.MapManager(this.container, {
                time_duration_millsecs: datetime.get_time_duration(),
                debug: this.options.debug
            });
            this.ocsmap.set_map_datetime_obj(datetime);
            this.ocsmap.addEvent('update_panel_options', this.on_update_panel_options.bind(this));
            this.ocsmap.addEvent('layer_group_added', this.on_layer_group_added.bind(this));
            this.ocsmap.set_model(this.get_model());
        }
        return this.ocsmap;
    },
    get_model: function () {
        if (!this.model) {
            var product = this.get_product();
            // Check if we have a wxscript
            if (product && product.product_content.contains('<?wxscript')) {
                this.model = new OCS.Viewer.Classes.WxScriptModel(product.product_content);
                this.model.addEvent('is_ready', this.bound_methods.render);
            }
        }
        return this.model;
    },
    get_panel_options: function () {
        if (!this.panel_options && this.container) {
            var panel_ops_el = new Element('div', {'class': "panel_options"}).inject(this.container);
            this.panel_options = new OCS.Viewer.Classes.PanelOptions(panel_ops_el);
            this.panel_options.addEvent(OCS.Viewer.Config.events.TOGGLE_LAYER_VISIBILITY, this.ocsmap.bound_methods[OCS.Viewer.Config.events.TOGGLE_LAYER_VISIBILITY]);
            this.panel_options.addEvent(OCS.Viewer.Config.events.TOGGLE_LAYER_LEGEND_VISIBILITY, this.ocsmap.bound_methods[OCS.Viewer.Config.events.TOGGLE_LAYER_LEGEND_VISIBILITY]);

        }
        return this.panel_options;
    },
    get_product: function () {
        return this.product;
    },
    set_product: function (prod) {
        this.product = prod;
    },
    remove_event_listeners: function () {
        if (this.html_controller) {
            var html = this.get_html_controller();
            html.destroy();
            this.html_controller = null;
        }

    },
    destroy: function () {
        if (this.map_datetime) {
            this.map_datetime.destroy();
            this.map_datetime = null;
        }
        if (this.model) {
            this.model.removeEvent('is_ready', this.bound_methods.render);
            this.model.destroy();
            this.model = null;
        }
        this.unlink_map();
        if (this.ocsmap) {
            this.ocsmap.destroy();
        }
        this.ocsmap = null;
        delete this.ocsmap;
        this.remove_event_listeners();
        this.initial_url_ops = {};
        delete this.options.entry_id;
        var controller_manager = OCS.Viewer.Functions.get_controller_manager();
        controller_manager.remove_map_ctrlr(this);
        this.removeEvents();
        this.$events = [];
        if (this.container) {
            this.container.removeEvents();
            this.container.store('viewer', null);
            this.container = null;
        }
    }
});

OCS.Viewer.Functions.add_radar = function (site) {
    if (site && site.id) {
        if (!site.name) {
            site.name = "New Radar";
        }
        if (!site.lat) {
            site.lat = 35.3331;
        }
        if (!site.lon) {
            site.lon = -97.2778;
        }
        OCS.Viewer.Config.default_radar_locations.push(site);
        return true;
    } else {
        console.debug('Failed to add radar due to no ID specified.');
        return false;
    }
};
